import { createApp } from 'vue';
import { createPinia } from 'pinia'
import App from './App.vue';
import router from './router';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import './assets/css/index.css';
import './assets/css/wang-view.css';

import '@vueup/vue-quill/dist/vue-quill.snow.css'
import '@wangeditor/editor/dist/css/style.css'
import { useDictionaryStore } from '@/store/dataDictStore'


if (process.env.NODE_ENV === 'development') {
  window.addEventListener('error', (e) => {
    if (e.message.includes('ResizeObserver')) {
      e.stopImmediatePropagation();
    }
  });
}


window.addEventListener('error', (event) => {
  console.log('全局错误监听:', event.error)
})

window.addEventListener('unhandledrejection', (event) => {
  console.log('未处理的Promise拒绝:', event.reason)
  // event.preventDefault() // 阻止默认处理（即输出错误到控制台）
})

const app = createApp(App);
const pinia = createPinia()
app.use(pinia)
app.use(router);
app.use(ElementPlus);
app.mount('#app');


const dictionaryStore = useDictionaryStore()
dictionaryStore.preloadCommonDictionaries().catch(console.error)



